/* @jsx h */
import { defineComponent, h, onMounted } from "vue";

import {} from "@app/vue/components/index";
import { useAuth } from "@app/vue/providers/index";
//
export const NotFoundPage = defineComponent({
  name: "NotFoundPage",
  setup() {
    const {} = useAuth();
    onMounted(() => {});
    return () => {
      return (
        <div class=" flex flex-1 flex-col items-center justify-center">
          <h1>404</h1>
        </div>
      );
    };
  },
});
